import '@bitbot/ui-design';
import './globals.css';
// import { SpeedInsights } from '@vercel/speed-insights/next';
import { GoogleAnalytics } from '@next/third-parties/google';
import type { NextComponentType } from 'next';
import type {
  AppContext,
  AppInitialProps,
  AppLayoutProps,
} from 'next/app';
import dynamic from 'next/dynamic';
import {
  Manrope,
  Noto_Sans_SC,
  Nunito,
  Nunito_Sans,
  Rubik,
} from 'next/font/google';
import Router from 'next/router';
import { useEffect } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import './globals.css';
import Script from 'next/script';
import { type Eruda } from 'eruda';

const manrope = Manrope({
  subsets: ['latin'],
  display: 'swap',
  weight: ['400', '700'],
  variable: '--font-manrope',
});
const nunitoSans = Nunito_Sans({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-nunito-sans',
  weight: ['200', '300', '400', '500', '600', '700', '800', '900'],
});

const nunito = Nunito({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-nunito',
  weight: ['200', '300', '400', '500', '600', '700', '800', '900'],
});
const rubik = Rubik({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-rubik',
  weight: ['300', '400', '500', '600', '700', '800', '900'],
});
const notoSansSC = Noto_Sans_SC({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-noto_sans_sc',
  weight: ['300', '400', '500', '600', '700', '800', '900'],
});

const App = dynamic(() => import('@/pages/entry'), { ssr: false });

const MyApp: NextComponentType<
  AppContext,
  AppInitialProps,
  AppLayoutProps
> = (props: AppLayoutProps) => {
  useEffect(() => {
    // 禁用滚轮 + ctrl放大缩小页面;
    window.addEventListener(
      'wheel',
      function (event) {
        if (event.ctrlKey === true || event.metaKey) {
          event.preventDefault();
        }
      },
      { passive: false },
    );
    Router.events.on('routeChangeComplete', () => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    });
  }, []);
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ENABLE_DEBUG === 'true') {
      let eruda: Eruda;
      const loadEruda = async () => {
        eruda = (await import('eruda')).default;
        eruda.init();
      };
      loadEruda();
      return () => {
        if (eruda) {
          eruda.destroy();
        }
      };
    }
  }, []);

  return (
    <>
      <style jsx global>{`
        :root {
          /* --font-manrope: ${manrope.style.fontFamily};
          --font-rubik: ${rubik.style.fontFamily};
          --font-nunito: ${nunito.style.fontFamily};
          --font-nunito-sans: ${nunitoSans.style.fontFamily};
          --font-noto_sans_sc: ${notoSansSC.style.fontFamily}; */
          --font-manrope: ${manrope.style.fontFamily};
          --font-rubik: ${manrope.style.fontFamily};
          --font-nunito: ${manrope.style.fontFamily};
          --font-nunito-sans: ${manrope.style.fontFamily};
          --font-noto_sans_sc: ${manrope.style.fontFamily};
        }
      `}</style>
      <Script
        id="init-telegram-game-proxy"
        strategy="beforeInteractive"
      >{`window.TelegramGameProxy = { receiveEvent() {} }`}</Script>
      <div className="mobile-wrap">
        <div className="mobile-content">
          <App {...props} />
        </div>
      </div>
      <GoogleAnalytics gaId="G-WSMZ7BMKGJ" />
      {/* <SpeedInsights /> */}
    </>
  );
};

export default MyApp;
